import { Component, Input, OnInit } from '@angular/core';
import { isEqual } from 'lodash';
import { emptyDatiqTooltip } from './models/datiq-tooltip-models-empty';
import { DatiqTooltipTypes } from './models/datiq-tooltip.enum';
import { IDatiqTooltip } from './models/datiq-tooltip.interface';
import { DatiqTooltipMapperService } from './services/datiq-tooltip-mapper.service';

@Component({
    selector: 'datiq-tooltip',
    templateUrl: './datiq-tooltip.component.html',
    styleUrls: ['./datiq-tooltip.component.scss'],
})
export class DatiqTooltipComponent implements OnInit {
    isOpen = false;
    _settings: IDatiqTooltip;
    @Input()
    get settings(): IDatiqTooltip {
        return this._settings;
    }
    set settings(value: IDatiqTooltip) {
        if (isEqual(value, this._settings)) return;

        this.isInfo = this._mapper.isInfo(this._settings);
        this._settings = { ...emptyDatiqTooltip, ...value };
    }
    isInfo: boolean;

    @Input() triggerClass: string = ``;
    @Input() triggerIconSize: number = 12;

    constructor(private _mapper: DatiqTooltipMapperService) {}

    ngOnInit(): void {
        this.settings = { ...emptyDatiqTooltip, ...this.settings };
        this.isInfo = this._mapper.isInfo(this.settings);
        this.triggerIconSize = !isNaN(this.triggerIconSize)
            ? this.triggerIconSize
            : 12;
        
    }
}
